import React from 'react'

import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import HelpIcon from '@material-ui/icons/Help'
import SaveIcon from '@material-ui/icons/Save'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Downloader from 'drawer/tabs/tools/DownloadMap/Downloader'
import downloadWorldFileImg from 'img/tools/noun-globe-338146.svg'
import { getMapAsCanvas } from 'utils/CanvasTools'
import { POZI_HOMEPAGE_URL } from 'utils/constants'
import { getMap } from 'utils/MapUtils'

import WorldFile from './WorldFile'

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 10
  },
  icon: {
    marginRight: theme.spacing(1),
    color: '#737373'
  },
  helpicon: {
    float: 'right',
    fontSize: 28,
    color: '#737373'
  },
  selectorButton: {
    color: '#737373',
    flex: '0 0 14em',
    justifyContent: 'flex-start',
    textTransform: 'none'
  },
  toggleContainer: {
    display: 'flex'
  },
  worldfile: {
    flexDirection: 'row',
    columnGap: 10
  },
  worldicon: {
    color: '#737373',
    height: 24,
    marginRight: theme.spacing(1)
  }
})

class DownloadMap extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      savingInProgress: false,
      worldfile: [],
      filename: ''
    }
  }

  saveMapImage = () => {
    const { config } = this.props
    const that = this
    const map = getMap()

    map.once('postrender', async function (event) {
      that.setState({ savingInProgress: true })
      try {
        const mapCanvas = await getMapAsCanvas()
        const mapDataURL = mapCanvas ? mapCanvas.toDataURL('image/png') : this.blankImage

        const title = get(config, 'title', 'PoziMap')
        const filestamp = new Date().filestamp() // Bespoke method 'filestamp'. See utils/helpers.js
        const filename = title + ' ' + filestamp + '.png'
        Downloader(mapDataURL, filename)

        const worldfile = WorldFile(mapCanvas.width, mapCanvas.height)
        that.setState({ worldfile, filename })
      } catch (e) {
        console.log('Error getting map image for print', e)
      } finally {
        that.setState({ savingInProgress: false })
      }
    })
    map.renderSync() // Triggers app.map.once rendercomplete
  }

  saveWorldFile = () => {
    const { worldfile, filename } = this.state
    const mimeType = 'text/plain'
    const worldFilename = filename + 'w'
    let data = ''
    for (const key in worldfile) {
      const value = worldfile[key]
      data += value + '\n'
    }
    Downloader(data, worldFilename, mimeType)
    this.setState({ worldfile: [] })
  }

  render () {
    const { savingInProgress, worldfile } = this.state
    const { classes } = this.props

    let worldFileButton = null
    if (worldfile.length > 0) {
      worldFileButton = (
        <div className={classes.worldfile}>
          <div className={classes.toggleContainer}>
            <Button variant="outlined" className={classes.selectorButton} onClick={this.saveWorldFile}>
              <img className={classes.worldicon} src={downloadWorldFileImg} alt="globe" />
              Save world file
            </Button>
            <Button>
              <a href={`${POZI_HOMEPAGE_URL}/user-guide/print/#save-map`} target="_blank" rel="noopener noreferrer">
                <Tooltip title="A 'world file' helps your desktop GIS applications to georeference your downloaded map image precisely to the GIS map. Click for more information." disableTouchListener={true} disableFocusListener={true}>
                  <HelpIcon className={classes.helpicon} />
                </Tooltip>
              </a>
            </Button>
          </div>
        </div>
      )
    }

    const saveButtonText = savingInProgress ? 'Saving, please wait...' : 'Save map as image'

    return (
      <div className={classes.root}>
        <div className={classes.toggleContainer}>
          <Button variant="outlined" className={classes.selectorButton} disabled={savingInProgress} onClick={this.saveMapImage}>
            <SaveIcon className={classes.icon} />
            {saveButtonText}
          </Button>
        </div>
        <div className={classes.toggleContainer}>
          {worldFileButton}
        </div>
      </div>
    )
  }
}

DownloadMap.propTypes = {
  classes: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired
}

function mapStateToProps (state, ownProps) {
  return {
    config: state.config
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(DownloadMap)
  )
)
